import { render, staticRenderFns } from "./InfoApprovalStamp.vue?vue&type=template&id=42aeb10d&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42aeb10d')) {
      api.createRecord('42aeb10d', component.options)
    } else {
      api.reload('42aeb10d', component.options)
    }
    module.hot.accept("./InfoApprovalStamp.vue?vue&type=template&id=42aeb10d&", function () {
      api.rerender('42aeb10d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/components/InfoApprovalStamp.vue"
export default component.exports